<div class="d-inline car-icons">




  <ng-template>

    <ng-container *ngIf="exceededDistancePolicy!=null">
      <div class="d-flex">
        <fa-icon class="custom-icon mr-1" [icon]="faRoad"></fa-icon>
        <div class="policyType">{{ policyType[policyType.ExceededDistancePolicy] | translate }}</div>
      </div>
      <ul class="policyRule">
        <ng-container *ngIf="exceededDistancePolicy.exceededDistancePolicyModel != null">
          <div [ngSwitch]="exceededDistancePolicy.exceededDistancePolicyModel.exceededDistancePolicyTypes">
            <div *ngSwitchCase="exceededDistancePolicyTypes.FreeDistance">
              <li>
                {{exceededDistancePolicyTypes[exceededDistancePolicy.exceededDistancePolicyModel.exceededDistancePolicyTypes]
                | translate}}
              </li>
              <li> {{'AllowedDistancePerRentalDay' | translate }} :
                {{exceededDistancePolicy.exceededDistancePolicyModel.allowedDistancePerRentalDay}}</li>

            </div>
            <div *ngSwitchCase="exceededDistancePolicyTypes.ApplyChargesOnExceededDistance">
              <!-- <li>{{'FreeDistance' | translate}}</li> -->
              <li>
                {{exceededDistancePolicyTypes[exceededDistancePolicy.exceededDistancePolicyModel.exceededDistancePolicyTypes]
                | translate}}
              </li>
              <li>{{'AllowedDistancePerRentalDay' | translate}} :
                {{exceededDistancePolicy.exceededDistancePolicyModel.allowedDistancePerRentalDay}}</li>
              <li>{{'Charge' | translate}} : {{exceededDistancePolicy.exceededDistancePolicyModel.charge}} /
                {{currency}}</li>

            </div>
          </div>
        </ng-container>
      </ul>
    </ng-container>

  </ng-template>


  <!-- Start DepositPolicy Type-->

  <ng-template #popContent1>

    <ng-container *ngIf="depositPolicy!=null">
      <div class="d-flex">
        <fa-icon [icon]="faDollarSign"></fa-icon>
        <div class="policyType">{{ policyType[policyType.DepositPolicy] | translate }}</div>
      </div>
      <ul class="policyRule">
        <ng-container *ngIf="depositPolicy.depositPolicyModel.minRequiredDeposit != null">
          <!-- <li>{{'NoPaymentIsRequired' | translate}}</li> -->
          <li>
            {{ depositPolicyPaymentTypes[depositPolicy.depositPolicyModel.depositPolicyPaymentTypes] | translate }}
            / {{depositPolicy.depositPolicyModel.minRequiredDeposit }} %
          </li>
          <!-- <li *ngFor="let policyRule of policy.policyRule">{{policyRule}}</li> -->
        </ng-container>
        <ng-container *ngIf="depositPolicy.depositPolicyModel.minRequiredDeposit == null">
          <li>{{ depositPolicyPaymentTypes[depositPolicy.depositPolicyModel.depositPolicyPaymentTypes] | translate }}
          </li>
        </ng-container>
      </ul>
    </ng-container>
  </ng-template>


  <div class="on-loader">
    <span class="loader-policy-icon spinner-border" *ngIf="loaderButton=='faDollarSign'"></span>
    <div class="loader-policy" [ngClass]="{'loader-policy': loaderButton=='faDollarSign'}">
      <button placement="top" type="button" #p1="ngbPopover" triggers="manual" (click)="loadPolicies('faDollarSign',p1)"
        id="faDollarSign" class="btn btn-icon" [ngbPopover]="popContent1" container="body">
        <fa-icon matTooltipPosition="above" [icon]="faDollarSign"></fa-icon>
      </button>
    </div>
  </div>

  <!-- End DepositPolicy Type-->


  <!-- Start Exceeded Distance -->
  <ng-template #popContent2>
    <ng-container *ngIf="exceededDistancePolicy!=null">
      <div class="d-flex">
        <fa-icon class="custom-icon mr-1" [icon]="faRoad"></fa-icon>
        <div class="policyType">{{ policyType[policyType.ExceededDistancePolicy] | translate }}</div>
      </div>
      <ul class="policyRule">
        <ng-container *ngIf="exceededDistancePolicy.exceededDistancePolicyModel != null">
          <div [ngSwitch]="exceededDistancePolicy.exceededDistancePolicyModel.exceededDistancePolicyTypes">
            <div *ngSwitchCase="exceededDistancePolicyTypes.FreeDistance">
              <li>
                {{exceededDistancePolicyTypes[exceededDistancePolicy.exceededDistancePolicyModel.exceededDistancePolicyTypes]
                | translate}}
              </li>
              <li> {{'AllowedDistancePerRentalDay' | translate }} :
                {{exceededDistancePolicy.exceededDistancePolicyModel.allowedDistancePerRentalDay}}</li>

            </div>
            <div *ngSwitchCase="exceededDistancePolicyTypes.ApplyChargesOnExceededDistance">
              <!-- <li>{{'FreeDistance' | translate}}</li> -->
              <li>
                {{exceededDistancePolicyTypes[exceededDistancePolicy.exceededDistancePolicyModel.exceededDistancePolicyTypes]
                | translate}}
              </li>
              <li>{{'AllowedDistancePerRentalDay' | translate}} :
                {{exceededDistancePolicy.exceededDistancePolicyModel.allowedDistancePerRentalDay}}</li>
              <li>{{'Charge' | translate}} : {{exceededDistancePolicy.exceededDistancePolicyModel.charge}} /
                {{currency}}</li>

            </div>
          </div>
        </ng-container>
      </ul>
    </ng-container>

  </ng-template>


  <div class="on-loader">
    <span class="loader-policy-icon spinner-border" *ngIf="loaderButton=='faRoad'"></span>
    <div [ngClass]="{'loader-policy': loaderButton=='faRoad'}">
      <button placement="top" type="button" #p2="ngbPopover" triggers="manual" id="faRoad"
        (click)="loadPolicies('faRoad',p2)" class="btn btn-icon" [ngbPopover]="popContent2" container="body">
        <fa-icon matTooltipPosition="above" [icon]="faRoad"></fa-icon>
      </button>
    </div>
  </div>
  <!-- End Exceeded Distance-->


  <!-- Start CancelationPolicy Type-->


  <ng-template #popContent4>
    <ng-container *ngIf="cancelationPolicy!=null">

      <div class="d-flex">
        <fa-icon [icon]="faBan"></fa-icon>
        <div class="policyType">{{ policyType[policyType.CancelationPolicy] | translate }}</div>
      </div>
      <ul class="policyRule">
        <ng-container *ngIf="cancelationPolicy.cancelationPolicyModel != null">
          <div [ngSwitch]="cancelationPolicy.cancelationPolicyModel.cancelationPolicyChargeTypes">
            <div *ngSwitchCase="cancelationPolicyChargeTypes.ApplyCancelationCharges">
              <!-- <li>{{'FreeCancelation' | translate }} </li> -->

              <li>
                {{cancelationPolicyChargeTypes[cancelationPolicy.cancelationPolicyModel.cancelationPolicyChargeTypes] |
                translate}}
              </li>

              <li>{{'CancelationChargePercentage' | translate}} :
                {{cancelationPolicy.cancelationPolicyModel.cancelationChargePercentage}} %
              </li>
              <li>{{'CancelationPeriod' | translate}} : {{cancelationPolicy.cancelationPolicyModel.cancelationPeriod}}
              </li>
            </div>
            <div *ngSwitchCase="cancelationPolicyChargeTypes.FreeCancelation">
              <li>
                {{cancelationPolicyChargeTypes[cancelationPolicy.cancelationPolicyModel.cancelationPolicyChargeTypes] |
                translate}}
              </li>
            </div>

          </div>
        </ng-container>
      </ul>
    </ng-container>

  </ng-template>

  <div class="on-loader">
    <span class="loader-policy-icon spinner-border " *ngIf="loaderButton=='faBan'"></span>
    <div class="loader-policy" [ngClass]="{'loader-policy': loaderButton=='faBan'}">
      <button placement="top" type="button" #p3="ngbPopover" triggers="manual" (click)="loadPolicies('faBan',p3)"
        id="faBan" class="btn btn-icon" [ngbPopover]="popContent4" container="body">
        <fa-icon matTooltipPosition="above" [icon]="faBan"></fa-icon>
      </button>
    </div>
  </div>
  <!-- End CancelationPolicy Type-->


  <!-- Start FuelChargingPolicy Type-->

  <ng-template #popContent3>
    <ng-container *ngIf="fuelChargingPolicy!=null">
      <div class="d-flex">
        <fa-icon [icon]="faBatteryHalf"></fa-icon>
        <div class="policyType">{{policyType[policyType.FuelChargingPolicy] | translate }}</div>
      </div>
      <ul class="policyRule">
        <ng-container *ngIf="fuelChargingPolicy.fuelChargingPolicyModel != null">
          <div [ngSwitch]="fuelChargingPolicy.fuelChargingPolicyModel.fuelChargingPolicyTypes">
            <div *ngSwitchCase="fuelChargingPolicyTypes.FreeFuel">
              <li>{{fuelChargingPolicy.fuelChargingPolicyModel.fuelChargingPolicyTypes}}</li>
            </div>
            <div *ngSwitchCase="fuelChargingPolicyTypes.ApplyCharges">
              <!-- <li>{{ 'FreeFuel' | translate }}</li> -->
              <li>{{fuelChargingPolicyTypes[fuelChargingPolicy.fuelChargingPolicyModel.fuelChargingPolicyTypes] |
                translate}}
              </li>
              <div *ngIf="fuelChargingPolicy.fuelChargingPolicyModel.fuelChargesList ">
                <li *ngFor="let itemfuelCharge of fuelChargingPolicy.fuelChargingPolicyModel.fuelChargesList">
                  <!--Todo: Here the fule type name is lookup-->
                  {{itemfuelCharge.fuelTypeName }} / {{itemfuelCharge.fuelLevel }} / {{itemfuelCharge.fuelCharge }}
                  {{currency}}
                </li>
              </div>
            </div>
          </div>

        </ng-container>
      </ul>

    </ng-container>
  </ng-template>

  <div class="on-loader">
    <span class="loader-policy-icon spinner-border" *ngIf="loaderButton=='faBatteryHalf'"></span>
    <div class="loader-policy" [ngClass]="{'loader-policy': loaderButton=='faBatteryHalf'}">
      <button placement="top" type="button" #p4="ngbPopover" triggers="manual"
        (click)="loadPolicies('faBatteryHalf',p4)" id="faBatteryHalf" class="btn btn-icon" [ngbPopover]="popContent3"
        container="body">
        <fa-icon matTooltipPosition="above" [icon]="faBatteryHalf"></fa-icon>
      </button>
    </div>
  </div>


  <!-- End FuelChargingPolicy Type-->




  <!--------------------------------->

  <ng-template #popContent5>
    <ng-container *ngIf="ageRestrictionPolicy!=null">
      <div class="d-flex calender-policy">
        <i class="far fa-calendar-alt"></i>
        <div class="policyType">{{policyType[policyType.AgeRestrictionPolicy] | translate }}</div>
      </div>
      <ul class="policyRule">
        <ng-container *ngIf="ageRestrictionPolicy.ageRestrictionPolicyModel != null">
          <div [ngSwitch]="ageRestrictionPolicy.ageRestrictionPolicyModel.ageRestrictionType">
            <div *ngSwitchCase="ageRestrictionPolicyTypes.NoAgeRestrictions">
              <li>{{ageRestrictionPolicyTypes[ageRestrictionPolicy.ageRestrictionPolicyModel.ageRestrictionType] | translate}}</li>
            </div>
            <div *ngSwitchCase="ageRestrictionPolicyTypes.ApplyChargesForSpecificAgeRangeAsARiskFactor">
              <!--         <li>{{'NoAgeRestrictions' | translate}}</li> -->
              <li>{{ageRestrictionPolicyTypes[ageRestrictionPolicy.ageRestrictionPolicyModel.ageRestrictionType] | translate}}</li>
              <div *ngIf="ageRestrictionPolicy.ageRestrictionPolicyModel.ageChargesList != null">
                <div *ngFor="let itemAgeCharges of ageRestrictionPolicy.ageRestrictionPolicyModel.ageChargesList">
                  <li>
                    {{'AgeFrom' | translate}} : <span class="yellow-text">{{itemAgeCharges.ageFrom}} ,{{'AgeTo' | translate}} : {{itemAgeCharges.ageTo}} ,{{'Charge' | translate}}</span> :
                    <span class="yellow-text"> {{itemAgeCharges.chargePercentage}} {{currency}} </span>
                  </li>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </ul>

    </ng-container>
  </ng-template>

  <div class="on-loader">
    <span class="loader-policy-icon spinner-border" *ngIf="loaderButton=='faCalendarAlt'"></span>
    <div class="loader-policy" [ngClass]="{'loader-policy': loaderButton=='faCalendarAlt'}">
      <button placement="top" type="button" #p5="ngbPopover" triggers="manual"
        (click)="loadPolicies('faCalendarAlt',p5)" id="faCalendarAlt" class="btn btn-icon" [ngbPopover]="popContent5"
        container="body">
        <fa-icon style="height: 20px !important;" matTooltipPosition="above" [icon]="faCalendarAlt"></fa-icon>
      </button>
    </div>
  </div>



  <!-- Start Age Restriction Type

  <ng-template  #popContent5 >
    <ng-container>
    <div class="d-flex">


      <div class="policyType">{{policyType[policyType.FuelChargingPolicy] | translate }}</div>
    </div>


  </ng-container>
  </ng-template>

  <div class="on-loader">
    <button placement="top" type="button" triggers="manual"   class="btn btn-icon"  [ngbPopover]="popContent5" container="body">
      <fa-icon matTooltipPosition="above" [icon]="faCalendarAlt"></fa-icon>
    </button>
  </div>





 End Age Restriction Type-->


























</div>
